/* Sedelle · hand-off to Shopify's checkout.
   Pressing «Pagar de forma segura» plays a 1.5 s brand sequence (ivory reveal from the button,
   the star drawing itself, a champagne ring filling up, three status lines) and then submits the
   cart form natively to Shopify's checkout. The veil is its own modal <dialog>, so it sits above
   the cart drawer (also a modal dialog, in the browser's top layer).
   - Esc during the 1.5 s cancels and returns to the cart.
   - prefers-reduced-motion: no sequence, the form is submitted at once.
   - Accelerated checkout buttons (Shop Pay, Apple Pay...) open their own sheets: untouched. */
(() => {
  const SUBMIT_AT = 1500;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  let veil = null;
  let timer = 0;
  let safety = 0;

  const STAR =
    'M12 2l2.35 6.76 7.16.15-5.71 4.33 2.08 6.85L12 16l-5.88 4.09 2.08-6.85-5.71-4.33 7.16-.15z';

  const markup =
    '<div class="sedelle-co-veil__sheet" aria-hidden="true"></div>' +
    '<div class="sedelle-co-veil__inner" role="status" aria-live="polite">' +
    '<div class="sedelle-co-veil__seal" aria-hidden="true">' +
    '<span class="sedelle-co-veil__ripple"></span>' +
    '<svg class="sedelle-co-veil__ring" viewBox="0 0 120 120" focusable="false">' +
    '<circle class="sedelle-co-veil__track" cx="60" cy="60" r="56"/>' +
    '<circle class="sedelle-co-veil__progress" cx="60" cy="60" r="56" pathLength="100"/>' +
    '<circle class="sedelle-co-veil__glint" cx="60" cy="60" r="56" pathLength="100"/>' +
    '</svg>' +
    '<svg class="sedelle-co-veil__star" viewBox="0 0 24 24" focusable="false">' +
    '<path d="' + STAR + '" pathLength="100"/></svg>' +
    '</div>' +
    '<p class="sedelle-co-veil__brand">Sedelle</p>' +
    '<p class="sedelle-co-veil__status">' +
    '<span>Preparando tu pedido</span>' +
    '<span>Conexión cifrada</span>' +
    '<span>Abriendo el pago seguro</span>' +
    '</p>' +
    '<p class="sedelle-co-veil__note">' +
    '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true" focusable="false">' +
    '<rect x="5" y="10.5" width="14" height="10" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
    '<path d="M8.5 10.5V7.8a3.5 3.5 0 0 1 7 0v2.7" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>' +
    'Pago procesado por Shopify. Sedelle no ve los datos de tu tarjeta.' +
    '</p>' +
    '</div>';

  const close = () => {
    clearTimeout(timer);
    clearTimeout(safety);
    if (!veil) return;
    if (veil.open) veil.close();
    veil.remove();
    veil = null;
  };

  const submit = (button) => {
    const form = button.form;
    if (!form) return;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(button);
    } else {
      const field = document.createElement('input');
      field.type = 'hidden';
      field.name = button.name;
      field.value = button.value || '';
      form.appendChild(field);
      form.submit();
    }
  };

  const open = (button) => {
    close();
    veil = document.createElement('dialog');
    veil.className = 'sedelle-co-veil';
    veil.setAttribute('aria-label', 'Abriendo tu pago seguro');
    veil.innerHTML = markup;

    // the ivory reveal starts where the customer pressed
    const rect = button.getBoundingClientRect();
    veil.style.setProperty('--sco-x', `${Math.round(rect.left + rect.width / 2)}px`);
    veil.style.setProperty('--sco-y', `${Math.round(rect.top + rect.height / 2)}px`);

    // Esc during the sequence: stay in the cart
    veil.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
      button.focus();
    });

    document.body.appendChild(veil);
    veil.showModal();
    veil.classList.add('is-on');

    timer = setTimeout(() => {
      veil?.classList.add('is-sent');
      submit(button);
    }, SUBMIT_AT);

    // if the page is still here long after (offline, blocked), give the cart back
    safety = setTimeout(close, SUBMIT_AT + 12000);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[name="checkout"]');
    if (!button || button.disabled || event.defaultPrevented || !button.form) return;
    if (!button.form.checkValidity()) return; // let the browser show what is missing
    if (reduced.matches) return; // native submit, no sequence

    event.preventDefault();
    if (veil) return; // already on its way
    open(button);
  });

  // back button restores the cart from cache: drop the veil
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) close();
  });
})();
